import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loading from "./Loading";
import Success from "./Success";
import Fail from "./Fail";

import "../css/ContactForm.css";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        inquiryType: "",
        salutation: "",
        firstName: "",
        lastName: "",
        company: "",
        phone: "",
        email: "",
        message: "",
        referralSource: ""
    });

    const currentLocation = useLocation(); // Get current location

    const isContactRoute = currentLocation.pathname.includes("contact"); // Check if on contact page
    const isProductRoute = currentLocation.pathname.includes("products");

    useEffect(() => {
        const existingScript = document.querySelector('script[src="https://www.google.com/recaptcha/api.js"]');
        if (!existingScript) {
            const script = document.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js";
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script);
            };
        }
    }, []);

    const [submitState, setSubmitState] = useState("idle");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitState("loading");

        const recaptchaResponse = window.grecaptcha?.getResponse();
        if (!recaptchaResponse) {
            alert("Please complete the reCAPTCHA verification.");
            setSubmitState("idle");
            return;
        }

        const formDataPayload = new FormData();

        const formDataToSend = { ...formData };


        // Append text fields
        Object.keys(formData).forEach((key) => {
            formDataPayload.append(key, formData[key]);
        });

        // Append reCAPTCHA token
        formDataPayload.append("recaptchaToken", recaptchaResponse);

        const apiEndpoint = "https://floteco2.com/api/contact/";

        try {
            const response = await fetch(apiEndpoint, {
                method: "POST",
                body: formDataPayload, // No need to set headers, fetch will automatically use `multipart/form-data`
            });

            const data = await response.json();

            if (response.ok && data.message === "Form submitted and email sent successfully!") {
                setSubmitState("success");
            } else {
                setSubmitState("fail");
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setSubmitState("fail");
        }
    };

    if (submitState === "loading") return <Loading />;
    if (submitState === "success") return <Success />;
    if (submitState === "fail") return <Fail />;

    return (
        <form className="contact-form" onSubmit={handleSubmit} encType="multipart/form-data">
            <h2>{isContactRoute ? "Contact Us" : "Request More Information"}</h2>

            {!isProductRoute && (
                <label>
                    Inquiry Type
                    <select name="inquiryType" value={formData.inquiryType} onChange={handleChange} required>
                        <option value="">Select an option</option>
                        <option value="General Inquiry">General Inquiry</option>
                        <option value="Product Inquiry">Product Inquiry</option>
                        <option value="Support Request">Support Request</option>
                    </select>
                </label>
            )}

            <label>
                Name <span className="required-asterisk">(required)</span>
                <div className="name-inputs">
                    <input
                        type="text"
                        name="firstName"
                        className="name-label"
                        placeholder="First Name"
                        required
                        value={formData.firstName}
                        onChange={handleChange}
                    />
                    <input
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        required
                        value={formData.lastName}
                        onChange={handleChange}
                    />
                </div>
            </label>

            {!isProductRoute && (
                <>
                    <label>
                        Company <span className="required-asterisk">(required)</span>
                        <input type="text" name="company" required value={formData.company} onChange={handleChange} />
                    </label>

                    <label>
                        Phone <span className="required-asterisk">(required)</span>
                        <input type="tel" name="phone" required value={formData.phone} onChange={handleChange} />
                    </label>
                </>
            )}

            <label>
                Email Address <span className="required-asterisk">(required)</span>
                <input type="email" name="email" required value={formData.email} onChange={handleChange} />
            </label>

            <label>
                Message <span className="required-asterisk">(required)</span>
                <textarea name="message" required value={formData.message} onChange={handleChange} />
            </label>

            {!isProductRoute && (
                <label>
                    How did you hear about us? <span className="required-asterisk">(required)</span>
                    <select name="referralSource" value={formData.referralSource} onChange={handleChange} required>
                        <option value="">Select an option</option>
                        <option value="Online Search">Online Search</option>
                        <option value="Word of Mouth">Word of Mouth</option>
                        <option value="Social Media">Social Media</option>
                        <option value="Advertisement">Advertisement</option>
                        <option value="Other">Other</option>
                    </select>
                </label>
            )}

            <div className="g-recaptcha" data-sitekey="6LdPkvgqAAAAAEiiW_9IPLU4XcAX8eXTe9NycIaX" data-action="LOGIN"></div>
            <br />

            <button type="submit" className="submit-button">
                Submit
            </button>
        </form>
    );
};

export default ContactForm;
